import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { BranchTreeComponent } from '../../../shared/components/branch-tree/branch-tree.component';
import { NgClass } from '@angular/common';
import { FieldTypeSwitchComponent } from '../../../shared/components/field-type-switch/field-type-switch.component';
import { FieldTypeTextSimpleComponent } from '../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'duplicate-modal',
    templateUrl: './duplicate-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FieldTypeTextSimpleComponent, FieldTypeSwitchComponent, NgClass, BranchTreeComponent, AfTranslatePipe]
})
export class DuplicateModalComponent implements OnInit {
  evaluationList: any = this.dialogConfig.data.evaluationList;
  duplicated: any = this.dialogConfig.data.duplicated;
  evaluation: any = this.dialogConfig.data.evaluation;
  listFolders: any = this.dialogConfig.data.listFolders;
  type: any = this.dialogConfig.data.type;
  duplicateModal: any={
    selected: null,
    copydata: null,
    copyreference: null,
    selectedEvaluation: false,
    lock: false,
    name: '',
    nameElement: {
      required:  true,
      label: this.translate.instant('duplicate-modal.name-element')
    },
    product: '',
    productName:''
  }

  constructor(private modalService: ModalServiceService,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private dialogRef: DynamicDialogRef<DuplicateModalComponent>,
    private dialogConfig: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.duplicateModal.product = this.evaluation.productTypeId;
    this.duplicateModal.productName = this.evaluation.productName;
    this.openFolders(this.evaluationList);
  }

  openFolders(children:any){
    for(let child of children){
      if(!this.duplicated.parentId && !this.duplicated.conceptId){
        this.productSelected();
      }else if(child.folderId === this.duplicated.parentId){
        this.duplicateModal.selected = child;
        child.selected = true;
      }else{
        if(this.duplicated.conceptId){
          for(let concept of child.concepts){
            if(concept.conceptId === this.duplicated.conceptId){
              child.selected = true;
              this.duplicateModal.selected = child;
              break;
            }
          }
        }
        if(this.duplicateModal.selected === null && child.children.length){
          this.openFolders(child.children);
        }
      }
      if(this.duplicateModal.selected !== null){
        child.show = true;
        break;
      }
    }

  }

  productSelected(){
    this.duplicateModal.selectedEvaluation = !this.duplicateModal.selectedEvaluation;
    this.deselectedEvaluation(this.evaluationList);
    this.duplicateModal.selected = this.evaluation;
  }

  deselectedEvaluation(children:any, show:string = ''){
    children.forEach((child: any) => {
      if(child){
        child.selected = false;
      }
      if(show === 'close'){
        child.show = false;
      }
      if(child.children.length){
        this.deselectedEvaluation(child.children, show);
      }
    });
  }

  selectChildrenOn(e:any){
    this.selectChildren( e.children);
  }

  selectChildren(children:any){
    if(this.duplicateModal.selected !== null && children.folderId === this.duplicateModal.selected.folderId){
      this.duplicateModal.selected = null;
    }else{
      if(this.duplicateModal.selected !== null){
        this.deselectedEvaluation(this.evaluationList);
        this.duplicateModal.selected.selected = false;
      }
      this.duplicateModal.selected = children;
    }
    children.selected = !children.selected;
  }

  optionSelected(evaluation:any){
    this.duplicateModal.selectedEvaluation = false;
    this.selectChildren(evaluation);
  }

  itemSelected(e:any){
    this.duplicateModal.name = e.newValue;
    delete this.duplicateModal.nameElement.error;
    delete this.duplicateModal.nameElement.errorText;
  }

  checkName(){
    if(this.duplicateModal.name?.length){
      this.duplicateModal.selectedEvaluation? this.checkEvaluationListNames() : this.checkFoldersAndConcepts();
    }else{
      this.duplicateModal.nameElement.error = true;
      this.modalService.errorModal({ text: this.translate.instant('duplicate-modal.error-check-name-modal')});
    }
  }

  checkEvaluationListNames(){
    let count : any = 1;
    for(let item of this.evaluationList){
      let name : any = item.name;
      count++;
      if(name.toLowerCase() === this.duplicateModal.name.toLowerCase()){
        this.errorDuplicateName();
        break;
      }else{
        this.duplicateModal.nameElement.error = false;
        if(count === this.evaluationList.length){
          this.handleAccept();
        }
      }
    }
  }

  checkFoldersAndConcepts(){
    let path: any = 'folders/existssubfolderinfolder/';
    let exist: any = {name: this.duplicateModal.name};
    if(!this.duplicated.folderId){
      path = 'concepts/existsconceptinfolder/';
      exist.title= this.duplicateModal.name;
      delete exist.name;
    }
    this.apiService.add(path + this.evaluation.evaluationId + '/'+ this.duplicateModal.selected.folderId, exist)
      .then((data:any)=>{
        if(data === false){
          this.duplicateModal.nameElement.error = false;
          this.handleAccept();
        }else{
          this.errorDuplicateName();
        }
      }, function(errorData){})
  }

  errorDuplicateName(){
    this.duplicateModal.nameElement.error = true;
    this.duplicateModal.nameElement.errorText = this.translate.instant('duplicate-modal.error-duplicate-name');
    this.modalService.errorModal({ text: this.translate.instant('duplicate-modal.error-check-name-modal')});
  }

  handleDismiss() {
    this.deselectedEvaluation(this.evaluationList, 'close');
    this.dialogRef.close({result:'cancel'});
  };

  handleAccept() {
    this.deselectedEvaluation(this.evaluationList, 'close');
    this.dialogRef.close({
      result: 'ok',
      selectFolder: this.duplicateModal.selected,
      name: this.duplicateModal.name,
      copydata: this.duplicateModal.copydata,
      copyreference : this.duplicateModal.copyreference
    })
  };
}
